export default __webpack_public_path__ + "static/media/wyndham6.6f17f4ba.png";